import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-finland',
    templateUrl: './finland.component.html',
    styleUrls: ['./finland.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FinlandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
